import { render, staticRenderFns } from "./CombRiskModal.vue?vue&type=template&id=36eab671&scoped=true&"
import script from "./CombRiskModal.vue?vue&type=script&lang=js&"
export * from "./CombRiskModal.vue?vue&type=script&lang=js&"
import style0 from "./CombRiskModal.vue?vue&type=style&index=0&id=36eab671&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eab671",
  null
  
)

export default component.exports